//environment variables
//alert("process.env.REACT_APP_BASE_URL " + process.env.REACT_APP_API_URL);
export const baseUrl = process.env.REACT_APP_API_URL;
//export const STUDENT_ID = process.env.REACT_APP_STUDENT_ID;
export const STUDENT_ID = (localStorage.getItem('studyapp_role') === 'parent') || (localStorage.getItem('studyapp_role') === 'teacher') ? localStorage.getItem('selectedStudentID') : localStorage.getItem('studyapp.com_userID');


// uncomment below for dev
// export const baseUrl = 'http://localhost:3006/'; //dev-test- mongodb
// export const STUDENT_ID = '65d026f5dbd27c2351868b31'; //DEV


// uncomment below for prod ---
// export const baseUrl = 'https://shark-app-5roti.ondigitalocean.app/' //New Prod access
// export const STUDENT_ID = '65d13fdca801472dc93051dd'; //PROD


